import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconPackageBlock: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="package-block,delivery"><path d="M10.75 20.25H3.75V3.75H8.75M8.75 3.75H15.25M8.75 3.75V9.25H15.25V3.75M15.25 3.75H20.25V9.75M15.25 14.25L19.7754 18.7754M20.1516 13.8483C21.6161 15.3128 21.6161 17.6872 20.1516 19.1517C18.6872 20.6161 16.3128 20.6161 14.8483 19.1517C13.3839 17.6872 13.3839 15.3128 14.8483 13.8483C16.3128 12.3839 18.6872 12.3839 20.1516 13.8483Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconPackageBlock;
